import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './admin/App';
import Login from "./login";
import UserApp from './user/UserModule';

import registerServiceWorker from './registerServiceWorker';

import { CircularProgress } from 'material-ui/Progress';
import {ajaxPost} from './ajax';
import Monitor from './monitor/monitor';

import TestForm from './TestForm';
import Contributors from './contributors';

const url = require('url');
const querystring = require('querystring');

function Logout()
{
    ajaxPost(
    {
        url: '/UserAPI/Logout',
        credentials:'include',
        data: "",
        onError:()=>{},
        onSuccess: data => {},
        finally: ()=>{window.location="Login"},
    });
}


const uri = url.parse(window.location.href);
var pathName = uri.pathname.toLowerCase();
var qs = querystring.parse(uri.query);
var query = uri.query != null ? uri.query.toLowerCase() : null;

switch( pathName )
{
    /*
    case '/testadmin':
        global.userType="ADMIN";
        ReactDOM.render(<App/>, document.getElementById('root'));
        break;
    
    case '/testmonitor':
        ReactDOM.render(<Monitor/>, document.getElementById('root'));
        break;
    case '/testsupp':
        global.userType = "SUPERVISOR";
        ReactDOM.render(<App/>, document.getElementById('root'));
        break;
    case '/testuser':
        global.employeeID=3757;
        global.company="5J";
        global.userName="rain";
        ReactDOM.render(<UserApp/>, document.getElementById('root'));
        break;
    case '/testform':
        ReactDOM.render(<TestForm title="test"/>, document.getElementById('root'));
        break;
    */
    case '/logout':
        Logout();
        break;
    case "/":
    case '/login':
        if( qs.redirect == null || qs.redirect == 'main' || qs.redirect == 'monitor' )
            ReactDOM.render(<Login redirect={qs.redirect}/>, document.getElementById('root'));
        else
            ReactDOM.render(<h1>Invalid Path</h1>, document.getElementById('root'));        
        break;
    case '/main':
    case '/monitor':
        ajaxPost(
            {
                url: '/UserAPI/CheckSession',
                credentials:'include',
                data: "",
                onError:()=>{},
                onSuccess: data => {
                    if( data != null && data.Expired == false && ("/"+data.Params) == pathName)
                    {
                        global.sessionID = data.SessionGUID;
                        global.userType = data.UserType;
                        global.company = data.Company;
                        global.userName = data.Username;
                        global.employeeID = data.EmployeeID;
                        global.department = data.Department;
                        switch( pathName )
                        {
                            case '/main':
                                if( data.UserType == 'USER' && window.screen.width < 800)
                                    ReactDOM.render(<UserApp />, document.getElementById('root'));
                                else
                                    ReactDOM.render(<App />, document.getElementById('root'));
                                break;
                            case '/monitor':
                                if( data.UserType != 'USER')                
                                    ReactDOM.render(<Monitor/>, document.getElementById('root'));
                                else
                                    ReactDOM.render(<h1>Access Denied</h1>, document.getElementById('root'));
                                break;
                        }
                    }
                    else
                        window.location = 'Login?redirect='+pathName.substring(1);
                },
                finally: ()=>{}
            }
        )
        ReactDOM.render(<CircularProgress size={30} />, document.getElementById('root'));
        break;
    default:
        ReactDOM.render(<h1>Invalid Path</h1>, document.getElementById('root'));


}
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js